
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/become-pro",
      function () {
        return require("private-next-pages/become-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/become-pro"])
      });
    }
  